module.exports = __webpack_public_path__ + "img/next_arrow.f2326a77.svg";